export default __webpack_public_path__ + "static/media/Dornakal-Diocese.a788b8d8.png";